
const terminalSettingsUtils = require('./terminalSettingsUtils');
const stringUtil = require('../../string/stringUtil');

module.exports.getReceiptPrinter = function()
{
    if (stringUtil.isStringNullOrEmpty(terminalSettingsUtils.getPrintSettings().receiptPrinter))
        return null;

    return terminalSettingsUtils.getPrintSettings().receiptPrinter;
}

module.exports.setReceiptPrinter = function(receiptPrinter)
{
    terminalSettingsUtils.getPrintSettings().receiptPrinter = receiptPrinter;
    terminalSettingsUtils.saveSettings();
}